/*
 * @Descripttion: 场地表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-03-08
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-03-08
 */

import http from '@/utils/kq/http'

const veSbzcCdInfoApi = {
  //添加接口
  add(data){
    return http.post(http.service.sbzc+'veSbzcCdInfo/add',data)
  },
  //删除接口
  delete(ids){
    return http.delete(http.service.sbzc+'veSbzcCdInfo/deleteBatch?ids='+ids)
  },
  //修改接口
  update(data){
    return http.put(http.service.sbzc+'veSbzcCdInfo/edit',data)
  },
  //分页查询接口
  page(pageData){
    return http.post(http.service.sbzc+'veSbzcCdInfo/page',pageData)
  },
  //查询单个数据接口
  get(id){
    return http.get(http.service.sbzc+'veSbzcCdInfo/queryById',{id:id})
  },
  //更新状态
  updateStatus(data){
    return http.post(http.service.sbzc+'veSbzcCdInfo/updateStatus',data)
  },

};
export default veSbzcCdInfoApi;
